import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexGrow: '1',
    padding: theme.spacing(0, 2, 4, 2),
    maxWidth: '100vw',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  justifyCenter: {
    justifyContent: 'center',
  },
}))
